import { useState, useRef, useEffect } from 'react';
import ItemsList from '../../ItemsList.js'; 
import { useToast } from '../../ui/Toast/ToastProvider.js';
import authService from '../../api-authorization/AuthorizeService.js';
import { deleteUsers } from '../../../services/userService.js'; 
import { useNavigate } from 'react-router-dom';
import { canManageUsers } from '../../../utils/authUtils.js';

const UsersSettings = () => {
    const itemsListRef = useRef(null); 
    const [selectedRows, setSelectedRows] = useState([]);
    const [hasAccess, setHasAccess] = useState(false);
    const [canAdd, setCanAdd] = useState(false);
    const { showToast } = useToast();
    const navigate = useNavigate(); 

    const [refreshKey, setRefreshKey] = useState(0);
    const handleUpdate = () => {
        setRefreshKey(k => k + 1);
        setSelectedRows([]);
    }
    const shouldUpdateList = () => refreshKey;

    useEffect(() => {
        const checkAccess = async () => {
            const access = await canManageUsers();
            setHasAccess(access);
            setCanAdd(access);
        };
        checkAccess();
    }, []);

    const baseColumns = [
        { id: 'email', name: 'Email', sortable: true, filter: 'search', selectId: null, labelFormat: 'clickToObject', aggregate: false },
        { id: 'roles', name: 'Roles', sortable: true, filter: null, selectId: null, labelFormat: null, aggregate: false },
    ];

    const allColumns = [
        ...baseColumns,
        
        { id: 'lockoutEnabled', name: 'Lockout enabled', sortable: true, filter: 'search', selectId: null, labelFormat: null, aggregate: false },
        { id: 'lockoutEnd', name: 'Lockout end', sortable: true, filter: null, selectId: null, labelFormat: 'date', aggregate: false },
    ];

    const [columns, setColumns] = useState(baseColumns);

    const mapFunction = (q) => {
        return {
            id: q.id,
            email: q.email,
            roles: q.roles.join(', '),
            roleArray: q.roles,
            lockoutEnabled: q.lockoutEnabled ? 'Yes' : 'No',
            lockoutEnd: q.lockoutEnd,
        };
    };

    const handleEditItem = async (user) => {    
        navigate(`/user/${user.id}`);
    };


    const handleAddUser = () => { 
        navigate(`/user/add`);
    };

    const handleDeleteSelected = async () => {
        if (selectedRows.length === 0) return;

        try {
            try {
                await deleteUsers(selectedRows);
            }
            catch (e) {
                showToast(e.message || 'Bulk delete failed', 'danger');
                return;
            }
            
            showToast(`Successfully deleted ${selectedRows.length} user${selectedRows.length === 1 ? '' : 's'}` , 'success');
            handleUpdate();
            setSelectedRows([]);

        } catch (err) {
            console.error('Error deleting users:', err);
            showToast('Error deleting users', 'danger');
        }
    };

    return (
        <div>
            {hasAccess && (
                <>
                    <div className="card mb-2">
                        <div className="card-body">
                            <span className="h5">Users</span>
                        </div>
                    </div>

                    <ItemsList
                        ref={itemsListRef}
                        allColumns={allColumns}
                        setColumns={setColumns}
                        columns={columns}
                        itemName="User"
                        mapFunction={mapFunction}
                        getItemsUrl="api/users"
                        uniqueIdColumn="id"
                        showHeader={true}
                        shouldUpdateList={shouldUpdateList}
                        editItemMethod={(user) => handleEditItem(user)}
                        itemUrlBase="users"
                        setSelectedRows={setSelectedRows}
                        selectedRows={selectedRows}
                        rowId="id"
                        bulkRemoveFunction={handleDeleteSelected}
                        addItemMethod={handleAddUser}
                        canAddItem={canAdd}
                    />
 
                </>
            )}
        </div>
    );
};

export default UsersSettings;
